@if (!_data.selected) {
    <svg
        data-testid="connection"
        [ngClass]="{
            disabled: _data.workflowEventData && !_data.workflowEventData.isEnabled,
            hasCondition: _data.workflowEventData && _data.workflowEventData.conditions && _data.workflowEventData.conditions.length !== 0,
            hidden: _data.visible === false,
        }">
        <path class="main" [attr.d]="connectionPath" />
        <path
            class="clickable-zone"
            [attr.d]="connectionPath"
            stroke="transparent"
            stroke-width="20"
            fill="none"
            (click)="_data.clicked(_data, true); $event.preventDefault(); $event.stopPropagation(); $event.stopImmediatePropagation()" />
    </svg>
} @else {
    <svg
        class="selected-connection"
        tabindex="0"
        [ngClass]="{
            disabled: !_data.workflowEventData.isEnabled,
            hasCondition: _data.workflowEventData && _data.workflowEventData.conditions && _data.workflowEventData.conditions.length !== 0,
            hidden: _data.visible === false,
        }">
        <path class="main" [attr.d]="connectionPath" />
        <path
            class="clickable-zone"
            [attr.d]="connectionPath"
            (click)="_data.clicked(_data, true); $event.preventDefault(); $event.stopPropagation(); $event.stopImmediatePropagation()" />
    </svg>
}
